import React from 'react';
import TopStepAccountPage, { type AccountPageProps, type TopStepAccountApi } from './TopStepAccountPage';
import topstepService from '../services/topstepService';

const NERDNODE_INSTANCE_ID = 'nerdnode-deeep';
const NERDNODE_FUNDED_ACCOUNT_ID = 23088078;
const NERDNODE_FUNDED_MARKERS = ['596610-89425435', '89425435', 'EXPRESS-V2-CT-DLL-596610'];

const nerdnodeFundedApi: TopStepAccountApi = {
  ...topstepService,
  getAccounts: () => topstepService.getInstanceAccounts(NERDNODE_INSTANCE_ID),
  startAccountAutopilot: (accountId, instruments) => topstepService.startInstanceAccountAutopilot(NERDNODE_INSTANCE_ID, accountId, instruments),
  stopAccountAutopilot: (accountId) => topstepService.stopInstanceAccountAutopilot(NERDNODE_INSTANCE_ID, accountId),
};

const matchNerdnodeFundedAccount: AccountPageProps['accountMatcher'] = (accounts) => {
  const exact = accounts.find((account) => account.accountId === NERDNODE_FUNDED_ACCOUNT_ID);
  if (exact) return exact;

  return accounts.find((account) => {
    const accountName = account.accountName || '';
    return NERDNODE_FUNDED_MARKERS.some((marker) => accountName.includes(marker));
  });
};

const TopStepNerdnodeFundedPage: React.FC = () => (
  <TopStepAccountPage
    accountLabel="TopStep NerdNode Funded"
    accountMatcher={matchNerdnodeFundedAccount}
    accountApi={nerdnodeFundedApi}
    challengeParams={{ target: 750, hardMax: 1000, internalStop: 1000, dailyCap: 1000, accountSize: 50000 }}
    chipLabel="NERDNODE FUNDED"
    chipColor="#D4AF37"
  />
);

export default TopStepNerdnodeFundedPage;